module.exports = __webpack_public_path__ + "static/gosee-0f85ecb424050348e43494e438611a46.png";